let viewIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    />
  </svg>
);

let EditIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
    />
  </svg>
);

let DownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    height="18"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
      clipRule="evenodd"
    />
  </svg>
);

let editIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
  </svg>
);

let eyeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    />
  </svg>
);

let leftIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="16"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
      clipRule="evenodd"
    />
  </svg>
);

let peopleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.942"
    height="17.264"
    viewBox="0 0 15.942 17.264"
  >
    <path
      id="yf-01"
      d="M31.667,9.8a5.316,5.316,0,1,0-6.439-8.41A5.181,5.181,0,0,0,23.506,5.1,5.29,5.29,0,0,0,26,9.813a7.91,7.91,0,0,0-5.122,7.446h1.283a6.664,6.664,0,0,1,5.318-6.5c0,.352,0,.677,0,1a.415.415,0,0,0,.061.25c.4.428.816.846,1.242,1.283-.421.428-.809.815-1.189,1.211a.384.384,0,0,0-.115.232c-.009.832-.006,1.664-.006,2.519h2.675V14.743a.3.3,0,0,0-.07-.19c-.4-.414-.812-.822-1.248-1.261.413-.419.8-.8,1.164-1.192a.638.638,0,0,0,.15-.367c.021-.317.007-.637.007-1.014A6.777,6.777,0,0,1,35.5,17.248h1.313A8.1,8.1,0,0,0,31.667,9.8Zm-2.872-.5a4,4,0,1,1,4-4,3.964,3.964,0,0,1-4,4Z"
      transform="translate(-20.866 0.006)"
      fill="currentColor"
    />
  </svg>
);

let trashIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </svg>
);

let buildingIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="me-3"
    width="21"
    height="21"
    viewBox="0 0 21 21"
  >
    <g id="new-construction" transform="translate(0 1.259)">
      <path
        id="Path_677"
        data-name="Path 677"
        d="M4.436,17.683H.5V8.5H1.812"
        transform="translate(0 1.558)"
        fill="none"
        stroke="#0064bb"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <line
        id="Line_2"
        data-name="Line 2"
        x2="2.624"
        transform="translate(7.183 12.928)"
        fill="none"
        stroke="#0064bb"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <line
        id="Line_3"
        data-name="Line 3"
        x2="2.624"
        transform="translate(7.183 15.305)"
        fill="none"
        stroke="#0064bb"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <line
        id="Line_4"
        data-name="Line 4"
        x2="2.624"
        transform="translate(7.183 10.403)"
        fill="none"
        stroke="#0064bb"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <path
        id="Path_678"
        data-name="Path 678"
        d="M10.193,4.09H3.5L11.532-.759,19.564,4.09V19.241H3.5V6.615h8.032V19.03"
        transform="translate(0.936 0)"
        fill="none"
        stroke="#0064bb"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <line
        id="Line_5"
        data-name="Line 5"
        y1="10.495"
        transform="translate(15.167 5.109)"
        fill="none"
        stroke="#0064bb"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
      <line
        id="Line_6"
        data-name="Line 6"
        y1="9.183"
        transform="translate(17.876 6.387)"
        fill="none"
        stroke="#0064bb"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </g>
  </svg>
);

let EmployeesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="me-3"
    width="20.993"
    height="21.01"
    viewBox="0 0 20.993 21.01"
  >
    <g id="Untitled-1-01" transform="translate(-4.257 -3.31)">
      <path
        id="Path_799"
        data-name="Path 799"
        d="M8.93,9.8a5.949,5.949,0,0,1,5.96-5.99,5.585,5.585,0,0,1,5.55,4.08"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <path
        id="Path_800"
        data-name="Path 800"
        d="M7.73,8.52,8.91,9.93l1.36-1.3"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <path
        id="Path_801"
        data-name="Path 801"
        d="M20.71,9.94a5.94,5.94,0,0,1-5.75,5.8,6.339,6.339,0,0,1-5.75-3.89"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <path
        id="Path_802"
        data-name="Path 802"
        d="M21.92,11.23,20.74,9.81l-1.36,1.31"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <g id="Group_482" data-name="Group 482">
        <ellipse
          id="Ellipse_38"
          data-name="Ellipse 38"
          cx="1.66"
          cy="1.64"
          rx="1.66"
          ry="1.64"
          transform="translate(13.23 6.2)"
          fill="none"
          stroke="#0064bb"
          strokeWidth="1"
        />
        <path
          id="Path_803"
          data-name="Path 803"
          d="M11.92,12.9V11.88a1.842,1.842,0,0,1,1.7-1.81h2.33a1.743,1.743,0,0,1,1.75,1.84v.98H11.92Z"
          fill="none"
          stroke="#0064bb"
          strokeWidth="1"
        />
      </g>
      <g id="Group_483" data-name="Group 483">
        <ellipse
          id="Ellipse_39"
          data-name="Ellipse 39"
          cx="1.52"
          cy="1.5"
          rx="1.52"
          ry="1.5"
          transform="translate(5.96 17.66)"
          fill="none"
          stroke="#0064bb"
          strokeWidth="1"
        />
        <path
          id="Path_804"
          data-name="Path 804"
          d="M4.76,23.82v-.93a1.527,1.527,0,0,1,1.57-1.67H8.47a1.541,1.541,0,0,1,1.61,1.69v.91Z"
          fill="none"
          stroke="#0064bb"
          strokeWidth="1"
        />
      </g>
      <g id="Group_484" data-name="Group 484">
        <ellipse
          id="Ellipse_40"
          data-name="Ellipse 40"
          cx="1.52"
          cy="1.5"
          rx="1.52"
          ry="1.5"
          transform="translate(13.25 17.66)"
          fill="none"
          stroke="#0064bb"
          strokeWidth="1"
        />
        <path
          id="Path_805"
          data-name="Path 805"
          d="M12.04,23.82v-.93a1.527,1.527,0,0,1,1.57-1.67h2.14a1.541,1.541,0,0,1,1.61,1.69v.91Z"
          fill="none"
          stroke="#0064bb"
          strokeWidth="1"
        />
      </g>
      <g id="Group_485" data-name="Group 485">
        <ellipse
          id="Ellipse_41"
          data-name="Ellipse 41"
          cx="1.52"
          cy="1.5"
          rx="1.52"
          ry="1.5"
          transform="translate(20.64 17.66)"
          fill="none"
          stroke="#0064bb"
          strokeWidth="1"
        />
        <path
          id="Path_806"
          data-name="Path 806"
          d="M19.43,23.82v-.93A1.527,1.527,0,0,1,21,21.22h2.14a1.541,1.541,0,0,1,1.61,1.69v.91Z"
          fill="none"
          stroke="#0064bb"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
);

let tasksIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="me-3"
    width="20.862"
    height="20.703"
    viewBox="0 0 20.862 20.703"
  >
    <g id="vfv-01" transform="translate(-4.905 -3.4)">
      <path
        id="Path_807"
        data-name="Path 807"
        d="M12.04,21.23H6.82a1.529,1.529,0,0,1-1.41-1.56v-14S5.28,3.9,6.92,3.9H21.03s1.55.08,1.55,2.11v8.41"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <line
        id="Line_27"
        data-name="Line 27"
        x2="6.43"
        transform="translate(12.07 8.73)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <line
        id="Line_28"
        data-name="Line 28"
        x2="6.43"
        transform="translate(12.07 12.24)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <line
        id="Line_29"
        data-name="Line 29"
        x2="6.43"
        transform="translate(12.07 15.7)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <path
        id="Path_808"
        data-name="Path 808"
        d="M14.4,19.47l4.1,3.92,6.9-7.47"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <circle
        id="Ellipse_42"
        data-name="Ellipse 42"
        cx="0.84"
        cy="0.84"
        r="0.84"
        transform="translate(8.2 11.4)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <circle
        id="Ellipse_43"
        data-name="Ellipse 43"
        cx="0.84"
        cy="0.84"
        r="0.84"
        transform="translate(8.2 14.86)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <circle
        id="Ellipse_44"
        data-name="Ellipse 44"
        cx="0.84"
        cy="0.84"
        r="0.84"
        transform="translate(8.2 7.89)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
    </g>
  </svg>
);

let accountantIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="me-3"
    width="21.168"
    height="20.997"
    viewBox="0 0 21.168 20.997"
  >
    <g id="uju-01" transform="translate(-5.7 -2.793)">
      <path
        id="Path_809"
        data-name="Path 809"
        d="M21.55,10.18V4.07a.709.709,0,0,0-.82-.77H7.05c-.85,0-.85.98-.85.98V22.45s.03.84.78.84H20.76a.829.829,0,0,0,.84-.86V19.67"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <line
        id="Line_30"
        data-name="Line 30"
        x2="8.05"
        transform="translate(8.51 7.12)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <line
        id="Line_31"
        data-name="Line 31"
        x2="10.89"
        transform="translate(8.51 9.69)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <line
        id="Line_32"
        data-name="Line 32"
        x2="8.19"
        transform="translate(8.51 12.08)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <line
        id="Line_33"
        data-name="Line 33"
        x2="10.61"
        transform="translate(8.51 14.75)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <line
        id="Line_34"
        data-name="Line 34"
        x2="8.19"
        transform="translate(8.51 17.11)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <path
        id="Path_810"
        data-name="Path 810"
        d="M18.24,20.9V19.07l5.52-9.38,1.44.88-5.39,9.42Z"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <path
        id="Path_811"
        data-name="Path 811"
        d="M24.11,9.11l1.49.94.59-1.01-1.48-.91Z"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <ellipse
        id="Ellipse_45"
        data-name="Ellipse 45"
        cx="1.21"
        cy="1.25"
        rx="1.21"
        ry="1.25"
        transform="translate(8.18 18.81)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
      <ellipse
        id="Ellipse_46"
        data-name="Ellipse 46"
        cx="1.21"
        cy="1.25"
        rx="1.21"
        ry="1.25"
        transform="translate(11.83 18.81)"
        fill="none"
        stroke="#0064bb"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export {
  viewIcon,
  EditIcon,
  DownIcon,
  editIcon,
  eyeIcon,
  leftIcon,
  peopleIcon,
  trashIcon,
  buildingIcon,
  EmployeesIcon,
  tasksIcon,
  accountantIcon,
};
